
<p-dialog [position]="'top'" appendTo="body" header="Comment Viewer" [style]="{ width: getResolutionWidth() }" [(visible)]="isOpenCommentViewer"
  [modal]="true" [maximizable]="true" (onHide)="this.closeDialogbox();" [scrollTop]="true">
  <div>
      <!-- Filter Code -->
      <div class="col-lg-12 nopadding">
        <mat-chip-listbox aria-label="filter">
          <span>
            @if(isDisplayDateRangeFilter) {
              <button type="button" class="date-btn" (click)="showDateFilter()">
                {{LastExecutionDate[0] === LastExecutionDate[1] || LastExecutionDate[1] === null ? 
                  this.userService.getyyyyMMddDateFormate(LastExecutionDate[0]) : 
                  this.userService.getyyyyMMddDateFormate(LastExecutionDate[0]) + ',' + 
                  this.userService.getyyyyMMddDateFormate(LastExecutionDate[1])}}
              </button>
            }
            @for (staticFilter of commentStaticFilters; track staticFilter.filterName; let ind = $index) {
              <mat-chip selected [matTooltip]="staticFilter.filterValue" [matTooltipShowDelay]="1000"
                matTooltipPosition="after" [id]="staticFilter.filterName">
                {{staticFilter.filterName}}: {{staticFilter.filterValue}}
              </mat-chip>
            }
          </span>
        </mat-chip-listbox>
      </div>
  </div>
  <div class="ui-grid-col-12">
    @if(isDataLoading) {
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
    }
    <p-table #dt 
      [value]="commentData" 
      [columns]="cols" 
      [resizableColumns]="true"
      [lazy]="true"  
      columnResizeMode="expand"  
      [(selection)]="selectedTableRows" 
      (selectionChange)="onSelectionChange($event)" 
      [paginator]="true" 
      appendTo="body" 
      alwaysShowPaginator="true" 
      paginatorPosition="both"
      showCurrentPageReport="true" 
      (onPage)="changePage($event)" 
      [rows]="rowcount" 
      [totalRecords]="totalRecords"
      [pageLinks]="constantService.DEFAULT_PAGELINKS" 
      [sortOrder]="constantService.DEFAULT_SORDORDER_ASC"
      sortMode="multiple"
      (onSort)="sort($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      paginatorDropdownAppendTo="body"
      (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td class="text-center" [attr.colspan]="columns.length">
            {{isDataLoading?constantService.LOADIND_DATA_MSG:constantService.NO_RECORDFOUND_MSG}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @if(pageName != 'Comparative Review' && pageName != this.compReviewServiceService.pageName){
          <th id="tableHeaderCheckbox" style="width: 3em">
            <p-tableHeaderCheckbox #tableHeaderCheckboxRef></p-tableHeaderCheckbox>
          </th>
        }
          @for(col of columns; track col; let i = $index) {
            <th [id]="col.header" 
              [ngClass]="(col?.display | lowercase) === 'false' ? 'notdisplay':'' " pResizableColumn [pSortableColumn]="col.field">
              <span>
                {{col.header}}
                @if((col.header | lowercase) !== 'action') {
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                }
              </span>
            </th>
          }
        </tr>
        <tr>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          @if(pageName != 'Comparative Review' && pageName != this.compReviewServiceService.pageName ){
          <td style="width: 3em;padding-left: 6px !important;" [class.ui-row-highlight]="['InActive'].includes(rowData['isActive'])">
            <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="rowData" [disabled]="['InActive'].includes(rowData['isActive']) ? true : false"></p-tableCheckbox>
          </td>
        }
          @for(col of columns; track col; let i = $index) {
            <td [ngClass]="(col?.display | lowercase) === 'false' ? 'notdisplay' : ''" [class.ui-row-highlight]="['InActive'].includes(rowData['isActive'])">
              <!-- set Date -->
              @if((col.datatype | lowercase)==='date') {
                <span>
                  @if(rowData[col.field] && rowData[col.field]!='null') {
                    <span>{{rowData[col.field] | date: 'yyyy-MM-dd'}}</span>
                  }
                </span>
              }

              <!-- set String -->
              @if((col.datatype | lowercase)==='string') {
                <span>
                  @if(rowData[col.field]!='null' && rowData[col.field]!='') {
                    <span>{{rowData[col.field]}}</span>
                  }
                </span>
              }
            </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorright">
        @if(!isDisabledDeleteBtn){
        <button type="button" matTooltip="Delete" [matTooltipShowDelay]="1000" id="delete-catalyst-comments" label="delete-catalyst-comments"
          class="exportBtn" (click)="removeRecords($event)"> Delete <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      }
        <button type="button" matTooltip="Export" [matTooltipShowDelay]="1000" id="export-catalyst-comments" label="export-catalyst-comments"
          class="exportBtn" (click)="exportToCSV()"> Export <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        Total Records: {{commentData.length === 0 ? 0 : totalRecords}}
      </ng-template>
    </p-table>
  </div>

  <!-- Add Comment Box -->
  @if(isDisplayAddCommentForm) {
    <div class="textClass">
      <div class="ui-grid-col-1 textClass">
      <label>Status</label>
      </div>
      <div class="ui-grid-col-9 textClass">
        @for(status of constantService.statusDropDwn; track status.value){
          <p-radioButton name="status" [value]="status.value" [(ngModel)]="selectedStatus" class="alignClass">
        </p-radioButton>
        <label>{{status.label}}</label>
        }
      </div>
    </div>
    <div>
      <form name="addCommentForm" #ProcessFlow="ngForm" novalidate>
        <div class="ui-grid ui-grid-responsive">
          <div class="ui-grid-col-1">
            <label for="comment">Comment</label>
          </div>
          <div class="ui-grid-col-9">
            <textarea pInputTextarea [required]="true" [maxLength]="maxCharsLength" [(ngModel)]="commentStatement" class="width-100"
              name="userComment" id="userComment"></textarea>
          </div>
          <div class="ui-grid-col-2 ui-g-nopad">
            <div class="ui-g">
              <div class="ui-g-1"></div>
              <div class="ui-g-10">
                @if(pageName != 'Comparative Review'){
                <button pButton type="button" id="AddComment" [disabled]="ProcessFlow.invalid" label="Add Comment"
                  icon="fa fa-check" class="ui-button-info btn-style" (click)="insertComment();"></button>
                }
              </div>
              <div class="ui-g-1"></div>
            </div>
          </div>
        </div>
        <div class="ui-grid ui-grid-responsive">
          <div class="text-right ui-grid-col-10">
            <span class="charsCounter"> Characters Remaining: 
              {{((commentStatement && commentStatement.length > 0) ? (maxCharsLength-commentStatement.length) : maxCharsLength)}}</span>
          </div>
          <div class="ui-grid-col-2"></div>
        </div>
      </form>
    </div>
  }
  <!-- End of Adding Comment Box -->
    <ng-template #footer>
    @if(pageName === 'Comparative Review'){
      <button pButton type="button" id="AddComment" label="Save"
    icon="fa fa-check" class="ui-button-info btn-style" (click)="insertComment();"></button>
    }
    <button pButton type="button" id="catalyst-comment-close" icon="fa fa-close" (click)="closeDialogbox()" label="Close" class="ui-button-secondary userActionBtn" style="background: #e54a23;"></button>
    </ng-template>
</p-dialog>

<!-- Confirmation Box -->
  <p-confirmDialog 
    id="catAnalyticsActionComfirmation"
    acceptLabel="Ok" 
    [rejectVisible]="true"
    key="DeleteconfirmationDialoge"
    appendTo="body" 
    header="Information" 
    icon="pi pi-exclamation-triangle" 
    [baseZIndex]="999999"
    styleClass="commentDialogBox">
  </p-confirmDialog>
<!-- End of Confirmation Box -->
<!-- Date Range Filter -->
  <p-dialog [(visible)]="isOpenDateRangeFilter" styleClass="quick-view-grid-row" icon="pi pi-exclamation-triangle"
  width="425" minHeight="0" appendTo="body" showEffect="fade" [modal]="true" (onHide)="isOpenDateRangeFilter = false"
  header="Date Filter">
    <div class="col-lg-12">
      <div class="col-lg-4"><label for="reportDate">Report Date</label></div>
      <div class="col-lg-8">
        <div>
            <app-datepicker-calendar [dateRange]="filterReportDate" [isDateRange]="true" (dateChange)="getDateEmitter()"></app-datepicker-calendar>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="col-lg-4"></div>
      <div class="col-lg-8">
        <button type="button" class="btn-DodgerBlue mg-t-5 float-right" id="ApplyFilter"
          (click)="applyFilter();isOpenDateRangeFilter=false;">Apply Filter
        </button>
      </div>
    </div>
  </p-dialog>
<!-- End of Filter -->